"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const components_1 = require("@/common/components");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const _1 = require(".");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const { profile_img_url } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.RoundImage, { size: 32, src: profile_img_url, altSrc: "/static/homepage/img/nav_profile.svg", additionalCss: { cursor: 'pointer' }, "aria-controls": open ? 'profile_menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: openMenu }), (0, jsx_runtime_1.jsxs)(Menu_1.default, Object.assign({ id: "profile_menu", anchorEl: anchorEl, autoFocus: false, disableScrollLock: true, open: open, onClose: handleClose, slotProps: { paper: { sx: { borderRadius: '24px' } } }, MenuListProps: {
                    sx: {
                        '> div:first-of-type': { borderRadius: '24px 24px 0 0' },
                        '> li:last-of-type': { borderRadius: '0 0 24px 24px' },
                        width: '375px',
                    },
                }, anchorOrigin: { vertical: 'bottom', horizontal: 52 }, transformOrigin: { vertical: 'top', horizontal: 'right' } }, { children: [(0, jsx_runtime_1.jsx)(_1.ProfileMenuItem, {}), (0, jsx_runtime_1.jsx)(_1.WalletMenuItem, {}), (0, jsx_runtime_1.jsx)(MenuDivider, {}), (0, jsx_runtime_1.jsx)(_1.HistoryMenuItem, {}), (0, jsx_runtime_1.jsx)(MenuDivider, {}), (0, jsx_runtime_1.jsx)(_1.SettingMenuItem, {}), (0, jsx_runtime_1.jsx)(_1.QnAMenuItem, {}), (0, jsx_runtime_1.jsx)(MenuDivider, {}), (0, jsx_runtime_1.jsx)(_1.SubscribeMenuItem, {}), (0, jsx_runtime_1.jsx)(_1.BlockListMenuItem, {}), (0, jsx_runtime_1.jsx)(MenuDivider, {}), (0, jsx_runtime_1.jsx)(_1.LogOutMenuItem, {})] }))] }));
}
exports.default = default_1;
const MenuDivider = styled_1.default.hr `
  padding-top: 5px;
  border: 0;
  margin: 0;
  background-color: #f8f8f8;
`;
